import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=5904b735&scoped=true"
import script from "./ProductMenu.vue?vue&type=script&lang=js"
export * from "./ProductMenu.vue?vue&type=script&lang=js"
import style0 from "./ProductMenu.vue?vue&type=style&index=0&id=5904b735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5904b735",
  null
  
)

export default component.exports